import IInput from '@inkline/inkline/src/components/IInput';

export default {
    name: 'ITextarea',
    extends: IInput
};
